import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneDance } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiMusic, FiDollarSign } from "react-icons/fi";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const dance: any = getOneDance();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const dance_id = dance?.dance_id;
  const [title, setTitle] = useState<any>(dance?.title);
  const [thumbnail, setThumbnail] = useState<any>(dance?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(dance?.image_cdn_id);
  const [venue, setVenue] = useState<any>(dance?.venue);
  const [venueCapacity, setVenueCapacity] = useState<any>(dance?.venue_capacity);
  const [startDate, setStartDate] = useState<any>(dance?.start_date);
  const [endDate, setEndDate] = useState<any>(dance?.end_date);
  const [startTime, setStartTime] = useState<any>(dance?.start_time);
  const [endTime, setEndTime] = useState<any>(dance?.end_time);
  const [email, setEmail] = useState<any>(dance?.email_address);
  const [payLink, setPayLink] = useState<any>(dance?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(dance?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(dance?.whatsapp);
  const [facebook, setFacebook] = useState<any>(dance?.facebook);
  const [twitter, setTwitter] = useState<any>(dance?.twitter);
  const [instagram, setInstagram] = useState<any>(dance?.instagram);
  const [youtube, setYoutube] = useState<any>(dance?.youtube);
  const [hashtags, setHashtags] = useState<any>(dance?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(dance?.google_map_code);
  const [latitude, setLatitude] = useState<any>(dance?.latitude);
  const [longitude, setLongitude] = useState<any>(dance?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    dance?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(dance?.featured);
  const [promoted, setPromoted] = useState<any>(
    dance?.promoted ? dance?.promoted : "no"
  );
  const [danceStatus, setDanceStatus] = useState<any>(dance?.status);
  const [description, setDescription] = useState<any>(dance?.description);
  const [expo, setExpo] = useState<any>(dance?.expo);
  const [pricing, setPricing] = useState<any>(dance?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const danceRoutes = "/data/dance";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneDanceHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : dance?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: danceStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: dance_id,
      data: data,
      content: _TYPES_.DANCE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={danceRoutes}
      eyebrow="DoSee Data • Dance"
      title="Edit Dance"
      subtitle={`Update a dance event or performance in ${entry_label || "this destination"}.`}
      icon={<FiMusic className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneDanceHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A photo from the performance or troupe."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.DANCES)}
        />
      </AddSection>

      <AddSection title="Dance Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="When the performance takes place."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="dance_status"
        setStatus={setDanceStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={danceStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
